window.$ = window.jQuery = require('jquery');
require('bootstrap-sass');
require('owl.carousel');
var Auth = require('./auth');
var Utils = require('./utils');

var urls = Utils.getUrls();
var chat_signup_url = urls.chat_signup_url;

function setBannerSize() {
  Utils.setBannerSize($('#main-banner'));
  Utils.setAnimationWidth($('.middle-column'));
  $(window).resize(function() {
    Utils.setBannerSize($('#main-banner'));
    Utils.setAnimationWidth($('.middle-column'));
  });
}

function startHeroImages() {
  // hero images
  var heroIndex = 2;
  var heroImages = [];
  var petTypes = ['cat', 'dog', 'critter'];
  var slideNumbers = ['01', '02', '03', '04'];
  var bannerEle = $('.banner-bg-wrapper');
  var heroType = Utils.getParameterByName('heroType');
  if(heroType && petTypes.indexOf(heroType) >= 0) {
    if(heroType === 'critter') slideNumbers = ['01', '02', '03'];
    heroImages = slideNumbers.map(function(slide) {
      return 'banner-item ' + heroType + ' slide-' + slide;
    });
  } else {
    petTypes.forEach(function(type) {
      if(type === 'critter') slideNumbers = ['01', '02', '03'];
      slideNumbers.forEach(function(slide) {
        heroImages.push('banner-item ' + type + ' slide-' + slide);
      });
    });
    Utils.shuffle(heroImages);
  }
  for(var h = 0; h < heroImages.length; h++) {
    var bannerClass = heroImages[h];
    if(h === 0) bannerClass = bannerClass + ' active';
    bannerEle.append(
      '<div class="'+ bannerClass + '"></div>'
    );
  }
  setInterval(function() {
    $('.banner-item').removeClass('active');
    $('.banner-item:nth-child('+ heroIndex +')').addClass('active');
    if(heroIndex < heroImages.length) {
      heroIndex++;
    } else {
      heroIndex = 1;
    }
  }, 7500);
}

function referralBanner() {
  var friendCode = Utils.getParameterByName('referrer');
  if(!friendCode) return false;
  Utils.getReferral(friendCode)
       .done(function(data) {
         $('.referral-header').removeClass('invisible');
         $('.banner-text').addClass('has-referral-banner');
         var headerImage = data.socialImageUrl;
         if(data.entry && data.entry.image) {
           headerImage = data.entry.image;
         } else {
           headerImage = data.profileImage;
         }
         if(headerImage) {
           $('.referral-header .photo').css({
             backgroundImage: 'url('+ headerImage +')',
             backgroundSize: 'cover'
           });
         } else {
           $('.referral-header .photo').addClass('initial').html(data.initial);
         }
         $('.referral-header .text .name').html(data.firstName + ' ' + data.lastName);
         var petType = data.entry && data.entry.petType ? data.entry.petType.toLowerCase() : 'pet'
         var petName = data.entry && data.entry.petName ? data.entry.petName : '';
         var info = 'My ' + petType + ' ' + petName +' is earning gift cards on Pet Parade. Signup your pet to share your cute pet pics and earn gift cards too!';
         $('.referral-header .text .info').html(info);
       });
}

function entriesSection() {
  Utils.getEntries()
    .done(function(all, dogs, cats, birds, horses, pigs, bunnies) {
      $('.entries-loading-wrap').hide();
      Utils.shuffle(all[0].entries);
      Utils.shuffle(dogs[0].entries);
      Utils.shuffle(cats[0].entries);
      Utils.shuffle(birds[0].entries);
      Utils.shuffle(horses[0].entries);
      Utils.shuffle(pigs[0].entries);
      Utils.shuffle(bunnies[0].entries);

      var allEntries = all[0].entries.slice(0, 10);
      $.each(allEntries, function(i, item) {
        var template = '<div class="img-grid" style="background-image:url('+ item.imageUrl +');"></div>'
        $('.tab-content #allpets').append(template);
      });
      var allDogs = dogs[0].entries.slice(0, 10);
      $.each(allDogs, function(i, item) {
        var template = '<div class="img-grid" style="background-image:url('+ item.imageUrl +');"></div>'
        $('.tab-content #dogs').append(template);
      });
      var allCats = cats[0].entries.slice(0, 10);
      $.each(allCats, function(i, item) {
        var template = '<div class="img-grid" style="background-image:url('+ item.imageUrl +');"></div>'
        $('.tab-content #cats').append(template);
      });
      var critters = birds[0].entries.slice(0, 1).concat(horses[0].entries.slice(0, 2)).concat(pigs[0].entries.slice(0, 6)).concat(bunnies[0].entries.slice(0, 6)).slice(0, 10);
      Utils.shuffle(critters);
      $.each(critters, function(i, item) {
        var template = '<div class="img-grid" style="background-image:url(https://assets.parade.pet/images/'+ item.image +'/medium.jpg);"></div>'
        $('.tab-content #critters').append(template);
      });
    })
    .fail(function(err) {
      console.log(err);
    });
}

function startPrizes() {
  Utils.getLatestPrizes().done(function(results) {
    var owlPrizes = $('.prizes-carousel');
    var giftcards = results.giftcards.filter(function(value, i, self) {
      var names = self.map(function(item) {
        return item.prizeName;
      });
      var indexOf = names.indexOf(value.prizeName);
      return indexOf === i;
    });
    var prizes = results.prizes.filter(function(value, i, self) {
      var names = self.map(function(item) {
        return item.prizeName;
      });
      var indexOf = names.indexOf(value.prizeName);
      return indexOf === i;
    });
    var finalGiftcard = giftcards.slice(0, 5).sort(function(a, b) {
      return b.id - a.id;
    });
    var finalPrizes = prizes.slice(0, (10 - finalGiftcard.length)).sort(function(a, b) {
      return b.id - a.id;
    });
    var finalData = finalGiftcard.concat(finalPrizes);
    for(var i = 0; i < finalData.length; i++) {
      var item = finalData[i];
      owlPrizes.append(
        '<div class="prize-item">'+
          '<div class="prize-user">'+
            '<img src="'+ item.userPhoto +'" class="owner-img">'+
            '<div class="owner-text">'+
              '<div class="owner-name">'+ item.user +'</div>'+
              '<div class="owner-meta">of '+ item.location +'</div>'+
            '</div>'+
            '<div class="time">'+ item.when +'</div>'+
          '</div>'+
          '<div class="prize-wrapper">'+
            '<div style="background-image:url('+ item.prizePhoto +')" class="prize-img"></div>'+
            '<div class="prize-name">'+ item.prizeName +'</div>'+
          '</div>'+
          '</div>'
      );
    }
    owlPrizes.owlCarousel({
      loop: false,
      slideBy: 'page',
      responsive: {
        0: { items: 1, stagePadding: 55, nav: false, dots: true },
        768: { items: 3, stagePadding: 0, nav: true, dots: false }
      }
    });
  });
}

function hypeAnimation() {
  var window_size = Utils.windowSize();
  if (window_size >= 768)  {
    $('.middle-column').html('<iframe class="anim" src="/character/character_443x304.html" allowtransparency="true"frameborder="0" scrolling="no" seamless></iframe>');
  }
  if (window_size == 414)  {
    $('.middle-column').html('<iframe class="anim" src="/character/character_443x304.html" allowtransparency="true"frameborder="0" scrolling="no" seamless></iframe>');
  }
  if (window_size == 375)  {
    $('.middle-column').html('<iframe class="anim" src="/character/character_355x244.html" allowtransparency="true"frameborder="0" scrolling="no" seamless></iframe>');
  }
  if (window_size == 320)  {
    $('.middle-column').html('<iframe class="anim" src="/character/character_300x206.html" allowtransparency="true"frameborder="0" scrolling="no" seamless></iframe>');
  }
}

function faq() {
  $('.panel-collapse').on('show.bs.collapse', function() {
    $(this).siblings('.panel-heading').addClass('active');
  });

  $('.panel-collapse').on('hide.bs.collapse', function() {
    $(this).siblings('.panel-heading').removeClass('active');
  });
}

function howItWorks() {
  var slideIndex = 2;
  var imagesLength = $('.how-it-works .images-updated img').length;
  $('.how-it-works .images-updated img:first-child').show();
  $('.how-it-works .text-updated li:first-child').addClass('active');
  $(window).one('start-how-it-works', function() {
    setInterval(function() {
      $('.how-it-works .images-updated img').hide();
      $('.how-it-works .images-updated img:nth-child('+ slideIndex +')').fadeIn();
      $('.how-it-works .text-updated li').removeClass('active');
      $('.how-it-works .text-updated li:nth-child('+ slideIndex +')').addClass('active');
      if(slideIndex < imagesLength) {
        slideIndex++;
      } else {
        slideIndex = 1;
      }
    }, 6000);
  });
}

$(document).ready(function() {
  setBannerSize();

  // Start hero images carousel
  startHeroImages();

  // Get Entries Data
  entriesSection();

  // Hype Animation Embed
  hypeAnimation();

  // FAQ panel
  faq();

  // Get Prizes
  startPrizes();

  // How It Works
  howItWorks();
  $(window).on('scroll resize', function() {
    var eleHIW = $('.how-it-works');
    var isVisible = Utils.isInViewPort(eleHIW);
    if(isVisible) $(window).trigger('start-how-it-works');
  });

  // Referral Banner
  referralBanner();

  // Auth Modal
  // signUpBtn pressed
  $('.signUpBtn').on('click', function(e) {
    e.preventDefault();
    var params = {};
    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str,key,value){
      params[key] = value;
    });
    var token = Utils.getCookie('token');
    if (params.app == 'ios') {
      window.location = 'petparade://addEntry';
    } else if (params.app == 'android') {
      window.location = 'https://v83s7.app.goo.gl/aC3A';
    } else if (token != null && token.length > 5) {
      Utils.redirectUser(chat_signup_url);
    } else {
      $('#signUpModal').modal('show');
    }
  });
  $('#signUpModal').on('shown.bs.modal', function() {
    $('#signUpForm #sfullName').focus();
  });

  // Open Login Form
  $('#goLogin').on('click', function(e) {
    e.preventDefault();
    $('#signUpModal').modal('hide');
    $('#loginModal').modal('show');
  });
  $('#loginModal').on('shown.bs.modal', function() {
    $('#loginForm #lemail').focus();
  });

  // Open Forgot Password Form
  $('#goForgot').on('click', function(e) {
    e.preventDefault();
    $('#loginModal').modal('hide');
    $('#forgotModal').modal('show');
  });
  $('#forgotModal').on('shown.bs.modal', function() {
    $('#forgotForm #femail').focus();
  });

  // Go to signup form
  $('#goSignUp').on('click', function(e) {
    e.preventDefault();
    $('#loginModal').modal('hide');
    $('#signUpModal').modal('show');
  });

  // Set input focus
  $('.form-control').keydown(function(e) {
    if(e && e.keyCode === 13) {
      e.preventDefault();
      var nextEle = $(this).parent().next();
      if(nextEle) {
        if(nextEle.is('button')) {
          nextEle.click();
        }
        if(nextEle.is('div')) {
          var nextInput = nextEle.find('.form-control');
          nextInput.focus();
        }
      }
    }
  });

  // Set phone format
  $('#phoneNumber').on('keyup', function() {
    var value = $(this).val();
    var formattedValue = Utils.formatPhone(value);
    $(this).val(formattedValue);
  });

  // Format Email Code to Uppercase
  $('#emailCode').on('keyup', function() {
    var value = $(this).val();
    var formattedValue = Utils.upperCase(value);
    $(this).val(formattedValue);
  });

  // Close verify email address modal
  $('#closeEmailCodeModal').on('click', function() {
    window.location.reload();
  });

  // Blur form when enter in email
  $('#signUpForm #semail').on('keyup', function(e) {
    if(e.key === 'Enter') {
      $('#signUpForm #semail').trigger('blur');
      $('#signUpForm #sfullName').trigger('blur');
    }
  });

  $('#signUpForm').on('submit', function(e) {
    e.preventDefault();
    $('#signUpForm #semail').trigger('blur');
    $('#signUpForm #sfullName').trigger('blur');
  });

  // Go Sign Up
  $('button.signUp.auth').on('click', function(e) {
    e.preventDefault();
    Auth.signUpEmail();
  });

  // Confirm Email Code
  $('button.emailCodeBtn.auth').on('click', function(e) {
    e.preventDefault();
    Auth.confirmEmailCode();
  });

  // Go Sign In
  $('button.logIn.auth.non-opt-out').on('click', function(e) {
    e.preventDefault();
    Auth.signInEmail();
  });

  // Go Sign In Opt-Out
  $('button.logIn.auth.opt-out').on('click', function(e) {
    e.preventDefault();
    var optType;
    var hasEmail = $(this).hasClass('email');
    if(hasEmail) optType = 'email';
    var hasSell = $(this).hasClass('sell');
    if(hasSell) optType = 'sell';
    Auth.signInEmail('optOut', optType);
  });

  // Request SMS Code
  $('button.phoneNumber.auth').on('click', function(e) {
    e.preventDefault();
    Auth.requestSmsCode();
  });

  // Submit SMS Code
  $('button.smsCode.auth').on('click', function(e) {
    e.preventDefault();
    Auth.submitSmsCode();
  });

  // Submit Email Verify
  $('button.emailVerify.auth').on('click', function(e) {
    e.preventDefault();
    Auth.verifyEmail();
  });

  // Email opt-out
  $('#opt-out-email').on('click', function(e) {
    e.preventDefault();
    var authToken = Utils.getCookie('token');
    if(authToken) {
      Auth.optOutEmail(authToken);
    } else {
      $('button.logIn.auth.opt-out').removeClass('sell').addClass('email');
      $('h3#opt-modal-title').html('Unsubscribe from all emails')
      $('p.opt-subtitle').html('Please login to your Pet Parade account to unsubscribe.');
      $('#optOutLoginModal').modal('show');
    }
  });

  // Sell opt-out
  $('#opt-out-sell').on('click', function(e) {
    e.preventDefault();
    var authToken = Utils.getCookie('token');
    if(authToken) {
      Auth.optOutSell(authToken);
    } else {
      $('button.logIn.auth.opt-out').removeClass('email').addClass('sell');
      $('h3#opt-modal-title').html('Do not sell my personal info');
      $('p.opt-subtitle').html('Please login to your Pet Parade account to opt out.');
      $('#optOutLoginModal').modal('show');
    }
  });

  // Close opt-out confirm modal
  $('.confirm-opt-out').on('click', function(e) {
    e.preventDefault();
    $('#optOutResultModal').modal('hide');
  });

  // Check cookieBanner
  var cookiePopUp = $('.cookie-popup-wrap');
  var cookieName = '_petparade_cookie_check';
  var cookieCheck = Utils.getCookie(cookieName);
  if(!cookieCheck) cookiePopUp.show();
  $('#set-check-cookie').on('click', function() {
    var cookieExpires = Utils.getCookieExpires();
    Utils.setCookie(cookieName, true, cookieExpires);
    cookiePopUp.hide();
  });

});
